import axios from 'axios';
import { API_URL } from '../../lib/const';

export const approveNotice = token => axios.post(`${API_URL}/onboarding/enrollments/${token}/approve_notice`).then(response => response.data);

export const approveTerm = token => axios.post(`${API_URL}/onboarding/enrollments/${token}/approve_term`).then(response => response.data);

export default approveNotice;
